import { defineComponent } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import NameCode from '@/presentation/components/campaign-settings/name/name.code';

export default defineComponent({
	components: {
		LoadingWrapper
	},
	setup: () => {
		const code = new NameCode();

		return {
			name: code.name,
			isLoading: code.isLoading,
			isFieldValidatedAndMissing: code.isFieldValidatedAndMissing,
			setNameBasedOnEvent: code.setNameBasedOnEvent.bind(code)
		};
	}
});
